import * as qs from 'querystring';

const GIPHY_API_KEY = import.meta.env.VITE_GIPHY_API_KEY;
const GIPHY_API_URL = import.meta.env.VITE_GIPHY_API_URL;

interface MBGIFAPIResponseItem {
  id: string;
  images: {
    original: {
      url: string;
      width: number;
      height: number;
      size: number;
    };
    downsized: {
      url: string;
      width: number;
      height: number;
      size: number;
    };
    preview_gif: {
      url: string;
      width: number;
      height: number;
      size: number;
    };
  };
}

interface MBGiphyAPIResponse {
  data: MBGIFAPIResponseItem[];
}

/*
    Class to interface with the Giphy API. For reference:
    https://developers.giphy.com/docs/
*/
class MBGiphyAPIClass {
  async query(url: string): Promise<MBGIF[]> {
    const res = await fetch(url);
    const gifs: MBGiphyAPIResponse = await res.json();

    // TODO(fant): proper error handling
    if (!gifs.data) {
      return [];
    }

    return gifs.data.map(
      (gif: MBGIFAPIResponseItem): MBGIF => ({
        id: gif.id,
        // TODO(fant): GIFs are not the most size efficient ways to show previews. Either:
        // 1. Use WebP (https://medium.com/@tgpski/aa9b1aa11405)
        // 2. Use video (react-native-video)
        // These steps require some more effort and would decrease data downloaded by ~50%
        url: gif.images.original.url,
        width: Number(gif.images.original.width),
        height: Number(gif.images.original.height),
        previewUrl: gif.images.preview_gif.url,
      }),
    );
  }

  /*
        Search for GIFs given a query, limit and offset
    */
  async search(q: string, limit: number = 0, offset: number = 0): Promise<MBGIF[]> {
    const query = { q, offset, limit, api_key: GIPHY_API_KEY };
    const url = `${GIPHY_API_URL}/search?${qs.stringify(query)}`;
    return this.query(url);
  }

  /*
        Get the trending GIFs
    */
  async trending(limit: number, offset: number = 0): Promise<MBGIF[]> {
    const query = { limit, offset, api_key: GIPHY_API_KEY };
    const url = `${GIPHY_API_URL}/trending?${qs.stringify(query)}`;
    return this.query(url);
  }
}

export const MBGiphyAPI = new MBGiphyAPIClass();
